'use client'

import { AppointmentProvider } from "@/context/appointment";
import React from "react";

export default function Layout({
    children,
}: {
    children: React.ReactNode,

}) {

    return <AppointmentProvider>
        {children}
    </AppointmentProvider>
};